import React from "react";

const NotebookAddMenu = ({
    isAddMenuOpen,
    setIsAddMenuOpen,

    notebookPages,

    setNewPageType,

    setLessonDraftTitle,
    setLessonDraftChapter,
    setLessonDraftSection,
    setLessonDraftNumber,
    
    setIsChapterWizardOpen,
    setIsLessonWizardOpen,

    createNotebookPage,
}) => {
    return (
        <div className="relative">
            <button
                type="button"
                onClick={() =>
                    setIsAddMenuOpen(
                        (currentValue) =>
                            !currentValue
                    )
                }
                className="
                    rounded-xl
                    border
                    border-[#c084fc]/45
                    bg-[#2b1548]/70
                    px-3
                    py-2
                    text-xs
                    font-semibold
                    text-[#f3e8ff]
                    transition
                    hover:border-[#ffd166]
                    hover:text-[#ffd166]
                "
            >
                + Add
            </button>

            {isAddMenuOpen && (
                <div
                    className="
                        absolute
                        right-0
                        z-30
                        mt-2
                        w-48
                        rounded-2xl
                        border
                        border-[#ffd166]/25
                        bg-[#05070d]
                        p-2
                        shadow-[0_0_24px_rgba(255,209,102,0.12)]
                    "
                >
                    {[
                        [
                            "chapter",
                            "New Chapter",
                        ],
                        
                        [
                            "lesson",
                            "New Lesson",
                        ],
                        [
                            "review",
                            "Review Page",
                        ],
                        [
                            "project",
                            "Project Page",
                        ],
                        [
                            "assessment",
                            "Quiz / Test Notes",
                        ],
                    ].map(
                        ([
                            type,
                            label,
                        ]) => (
                            <button
                                key={type}
                                type="button"
                                onClick={() => {
                                    setNewPageType(
                                        type
                                    );

                                    setIsAddMenuOpen(
                                        false
                                    );
                                    
                                    if (
                                        type ===
                                        "chapter"
                                    ) {
                                        setIsChapterWizardOpen(
                                            true
                                        );

                                        return;
                                    }

                                    if (
                                        type ===
                                        "lesson"
                                    ) {
                                        setLessonDraftTitle(
                                            ""
                                        );

                                        setLessonDraftChapter(
                                            ""
                                        );

                                        setLessonDraftSection(
                                            ""
                                        );

                                        setLessonDraftNumber(
                                            String(
                                                notebookPages.length +
                                                    1
                                            )
                                        );

                                        setIsLessonWizardOpen(
                                            true
                                        );

                                        return;
                                    }

                                    createNotebookPage(
                                        type
                                    );
                                }}
                                className="
                                    w-full
                                    rounded-xl
                                    px-3
                                    py-2
                                    text-left
                                    text-xs
                                    text-[#fff3c4]
                                    transition
                                    hover:bg-[#2b1548]/60
                                    hover:text-[#ffd166]
                                "
                            >
                                {label}
                            </button>
                        )
                    )}
                </div>
            )}
        </div>
    );
};

export default NotebookAddMenu;